import Api from "./api";

class PlanApi extends Api {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "plans/";
	}

	getPlan(facility, date, onSuccess, onError) {
		this.Get(
			this.baseUrl +
				`fetch/?facility=${facility.split("/").slice(-2)[0]}&date=${date.toISOString().split("T")[0]}`,
			onSuccess,
			onError
		);
	}

	async generatePlan(facility, date, onStart, onEnd, onSuccess, onError) {
		onStart();

		try {
			const response = await fetch(
				this.baseUrl +
					`generate/?facility=${facility.split("/").slice(-2)[0]}&date=${date.toISOString().split("T")[0]}`,
				{
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: this.getToken(),
					},
				}
			);

			if (!response.ok) {
				if (response.status === 401) this.onUnauthorized();
				throw response;
			}

			const response_json = await response.json();

			if (response_json.status === "success") {
				onSuccess();
			} else if (response_json.status === "infeasible") {
				const message =
					"There is no feasible solution due to contradictory constraints. Please, revise constriants " +
					"for the following points:" +
					response_json.detail;
				onError(message);
			} else if (response_json.status === "error") {
				const message = "Error:" + response_json.detail;
				onError(message);
			}
		} catch (err) {
			const message = "Problem generating plan.";
			onError(message);
		}

		onEnd();
	}

	async generatePlanAsync(facility, date, onStart, onEnd, onSuccess, onError) {
		onStart();

		try {
			const response = await fetch(
				this.baseUrl +
					`generate_async/?facility=${facility.split("/").slice(-2)[0]}&date=${date.toISOString().split("T")[0]}`,
				{
					method: "POST",
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: this.getToken(),
					},
				}
			);

			if (!response.ok) {
				if (response.status === 401) this.onUnauthorized();
				throw response;
			}

			const response_json = await response.json();

			if (response_json.status === "enqueued") {
				return await response_json.task_id;
			}
		} catch (err) {
			const message = "Problem generating plan.";
			onError(message);
		}

		onEnd();
	}

	async getPlanStatus(taskId, onSuccess, onError) {
		this.Get(this.baseUrl + `status/?task_id=${taskId}`, onSuccess, onError);
	}

	getReport(facility, fromDate, toDate, onSuccess, onError, aggType) {
		let endPoint =
			this.baseUrl +
			`report/?facility=${facility.split("/").slice(-2)[0]}&from_date=${fromDate.toISOString().split("T")[0]}&to_date=${toDate.toISOString().split("T")[0]}`;

		if (aggType) {
			endPoint = endPoint + `&agg=${aggType}`;
		}
		this.Get(endPoint, onSuccess, onError);
	}

	getCurrent(facility, onSuccess, onError) {
		this.Get(
			this.baseUrl + `current/?facility=${facility.split("/").slice(-2)[0]}`,
			onSuccess,
			onError
		);
	}


	getExcel(facility, date, onSuccess, onError) {

        fetch(
            this.baseUrl + `excel/?facility=${facility.split("/").slice(-2)[0]}&date=${date.toISOString().split('T')[0]}`,
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.getToken()
                }
            }
        ).then(
            (response) => {

                if (!response.ok) {
                    if (response.status === 401)
                        this.onUnauthorized()
                    throw response
                }
                return response.blob()
            }
        ).then(
            (blob) => {
                onSuccess(blob)
            }
        ).catch(
            () => onError()
        )



    }
}

export default PlanApi;
